/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExpenseStatus = {
    Submitted: 'SUBMITTED',
    Approved: 'APPROVED',
    ApprovalBlocked: 'APPROVAL_BLOCKED',
    Paid: 'PAID',
    BatchCreated: 'BATCH_CREATED'
} as const;
export type ExpenseStatus = typeof ExpenseStatus[keyof typeof ExpenseStatus];


export function instanceOfExpenseStatus(value: any): boolean {
    for (const key in ExpenseStatus) {
        if (Object.prototype.hasOwnProperty.call(ExpenseStatus, key)) {
            // @ts-ignore
            if (ExpenseStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExpenseStatusFromJSON(json: any): ExpenseStatus {
    return ExpenseStatusFromJSONTyped(json, false);
}

export function ExpenseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseStatus {
    return json as ExpenseStatus;
}

export function ExpenseStatusToJSON(value?: ExpenseStatus | null): any {
    return value as any;
}

